<mcm-loader [loading]="loading()">
  <ion-header
    class="mcm-header"
    [ngClass]="extraClasses()">
    @if (showToolbar()) {
      <ion-toolbar>
        <div class="mcm-header__title">
          @if (title()) {
            <h2>
              <span>{{ title() | translate: titleParams() }}</span>
            </h2>
          }
          <ng-container *ngTemplateOutlet="titleTemplate" />
        </div>

        <ion-buttons slot="start">
          @if (showBackButton() && !routerEventsService.isDefaultRoute) {
            <app-button
              class="mcm-header__close-button"
              icon="arrow-left-rounded"
              [disabled]="disableNavigateBack()"
              (onClick)="onBackNavigation()" />
          }
          <ng-container *ngTemplateOutlet="startButtonsTemplate" />
        </ion-buttons>

        <ion-buttons slot="end">
          <ng-container *ngTemplateOutlet="endButtonsTemplate" />
        </ion-buttons>
      </ion-toolbar>
    }

    <ng-container *ngTemplateOutlet="contentTemplate" />
  </ion-header>
</mcm-loader>
